import { AppStore, DeviceType } from '../model/types';

export const DEVICE_APP_STORES: Record<DeviceType, AppStore> = {
  [DeviceType.Ios]: AppStore.AppStore,
  [DeviceType.Android]: AppStore.GooglePlay,
  [DeviceType.AppGallery]: AppStore.AppGallery,
};

export const APP_STORE_DEVICE_TYPES: Record<AppStore, DeviceType> = {
  [AppStore.AppStore]: DeviceType.Ios,
  [AppStore.GooglePlay]: DeviceType.Android,
  [AppStore.AppGallery]: DeviceType.AppGallery,
};

export const APP_STORE_LABELS: Record<AppStore, string> = {
  [AppStore.AppStore]: 'App Store',
  [AppStore.GooglePlay]: 'Google Play',
  [AppStore.AppGallery]: 'AppGallery',
};

export const APP_STORE_ANALYTICS_NAMES: Record<AppStore, string> = {
  [AppStore.AppStore]: 'AppStore',
  [AppStore.GooglePlay]: 'GooglePlay',
  [AppStore.AppGallery]: 'AppGallery',
};

export const APP_STORES_WITH_BADGE: readonly AppStore[] = [AppStore.AppStore, AppStore.GooglePlay];
